<template>
  <div class="latest-uploading">
    <div class="header">
      <img src="@/assets/最新上传.png" alt />
      <div>最新上传</div>
    </div>
    <el-table
      :data="items"
      style="width: 100%"
      header-cell-class-name="my-header-cell"
      header-row-class-name="my-header-row"
      cell-class-name="my-cell"
      @row-click="click"
    >
      <el-table-column label="商品" width="90">
        <template slot-scope="scope">
          <el-image
            style="width: 70px; height: 70px; border-radius: 10%"
            :src="util.getImageUrl(util.getHead(util.string2Array(scope.row.images)), '100x100')"
            fit="cover"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column label="商品描述" style="text-align: left;">
        <template slot-scope="scope">
          <div class="intro">
            <div class="name">{{scope.row.name}}</div>
            <div class="features">{{scope.row.features}}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="上传时间" width="130">
        <template slot-scope="scope">
          <div class="date">{{util.toDateString(util.toDate(scope.row.createTime))}}</div>
          <div class="time">{{util.toTimeString(util.toDate(scope.row.createTime))}}</div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "LatestUploading",
  computed: {
    items() {
      return this.$store.state.product.productBase.latestUploading;
    }
  },
  methods: {
    click(e) {
      window.open(`/product/baike/${e.id}`);
    }
  }
};
</script>

<style lang="less">
.latest-uploading {
  .el-table__header-wrapper {
    margin-bottom: 15px;
  }

  .el-table::before {
    height: 0px;
  }

  .my-header-row {
    background: white;
  }

  .my-header-cell {
    background: #f8f8f8;
    color: #848791;
    padding: 8px 0px;
  }

  .my-header-cell:first-child {
    text-align: center;
    border-radius: 28px 0 0 28px;
  }

  .my-header-cell:nth-child(2) {
    text-align: center;
  }

  .my-header-cell:nth-child(3) {
    border-radius: 0 28px 28px 0;
  }

  .my-cell {
    padding: 7px 0px;
    border: 0;
    cursor: pointer;
    color: #848791;
  }

  .my-cell:nth-child(2) {
    text-align: center;
  }
}
</style>

<style lang="less" scoped>
.latest-uploading {
  width: 535px;
  display: inline-block;
  margin-left: 15px;

  .intro {
    height: 76px;

    vertical-align: top;
  }

  .name {
    color: #333;
    font-weight: 500;
    text-align: center;
    line-height: 30px;
  }

  .features {
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    font-size: 12px;
    line-height: 23px;
  }

  .header {
    margin: 40px 0 20px 0;
    text-align: center;
    img {
      width: 40px;
      height: 40px;

      display: inline-block;
      vertical-align: top;

      margin-right: 15px;
    }
    div {
      display: inline-block;
      height: 40px;
      line-height: 40px;
      font-size: 20px;
      font-weight: 600;
      color: #333;
      vertical-align: top;
      font-family: "FZQKBYSJW";
    }
  }
}
</style>


